import Vue from 'vue'
import Router from 'vue-router'
import common from './common'
import systemManage from './systemManager'
import deviceManage from './deviceManage'
import securityManage from './securityManage'
import businessManage from './businessManage'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...systemManage,
    ...deviceManage,
    ...securityManage,
    ...businessManage,
    ...common
    
  ]
})

/***************** 路由过滤 ***************************/
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'// Progress 进度条样式
nprogress.configure({ showSpinner: false })

const whiteList = ['Login','RegisterPic','QrCode','Mapnew','Homenew','FQrCode','Union']//路由过滤白名单
router.beforeEach((to, from, next) => {
  nprogress.start()
  if (whiteList.indexOf(to.name) > -1) {
    return next();
  }
  var access_token = sessionStorage.getItem('access_token');
  if (access_token) {//判断是否已登录
    return next();
  } else {//没登录跳转登录页
    return next({ path: `/`, replace: true })
  }
})
router.afterEach(() => {
  nprogress.done()
})

export default router
